<div id="ramadan-background">
    <div id='stars'></div>
    <div id='stars2'></div>
    <div id='stars3'></div>
</div>



<router-outlet></router-outlet>

<app-ramadan20-footer></app-ramadan20-footer>